export const EXTENSION_ANSWERS =
  "https://rus-na5.ru/xapi/cmi5/extension/answers";
export const EXTENSION_QUESTIONS =
  "https://rus-na5.ru/xapi/cmi5/extension/questions";
